import dayjs from "dayjs";

export const handleKeyDown = (e, fn) => {
    if (e.key === 'Enter') {
        e.preventDefault();
        fn();
    }
};

export const isValid = (val) => {
    return !isInvalid(val);
}

export const isInvalid = (val) => {
    return val === null || val === undefined;
}

export const convertToUTC9 = (timestamp) => {
    if (!timestamp) return '';
    return dayjs.unix(timestamp).utcOffset(9).format('YYYY-MM-DD HH:mm:ss');
};

export const transformData = (data) => {
    const tree = {};

    let i = 0;
    data.forEach(item => {
        const parts = item.split('/');
        let current = tree;

        parts.forEach((part, index) => {
            if (!current[part]) {
                current[part] = {
                    key: i++,
                    name: part,
                    children: {},
                    ...(index === parts.length - 1 ? {...item} : {})
                };
            }
            current = current[part].children;
        });
    });

    const buildTree = (node) => {
        return Object.values(node).map(({key, name, children, ...rest}) => ({
            id: key,
            label: name,
            children: buildTree(children),
            ...rest
        }));
    };

    return buildTree(tree);
};

export const removeStringWhitespace = (str) => {
    return str.replace(/\s+/g, '');
}

export const isJSON = (input) => {
    try {
        const parsed = JSON.parse(input);
        return typeof parsed === 'object' && parsed !== null;
    } catch (e) {
        return false;
    }
}

export const getItemString = (textList, items) => {
    const names = JSON.parse(items).map(item => {
        const name = textList.find(e => e.index === parseInt(item.id) && e.itemType === item.type)?.name || item.id;
        return `${name} (${item.quantity})`;
    });
    return names.join(', ');
}

const getETCItemName = (itemId, productId) => {
    console.log('getETCItemName', itemId, productId);
    if (productId.length === 0 || productId === 'undefined') {
        return itemId;
    }
    if (productId?.startsWith('com.actgames.hkmds.weekpass')) return '주간 패스';
    if (productId?.startsWith('com.actgames.hkmds.ch')) return '체인패키지' + productId.slice(-1);

    const ETCNames = {
        'com.actgames.hkmds.season1': '럭셔리 월간 패스',
        'com.actgames.hkmds.season2': 'VIP 월간 패스',
        'com.actgames.hkmds.season3': '럭셔리 월간 패스(추가)',
        'com.actgames.hkmds.season4': 'VIP 월간 패스(마지막 기회)',
        'com.actgames.hkmds.energymax01': '에너지 월정액',
        'com.actgames.hkmds.energymax02': '에너지 월정액(연장)',
        'com.actgames.hkmds.adsfree1': '광고 월정액',
        'com.actgames.hkmds.adsfree2': '광고 월정액(연장)',
        'com.actgames.hkmds.energym': '별이 쏟아지는 타운!'
    };

    return ETCNames[productId] || itemId;
}

export const getItemName = (textList, itemId, itemType, productId = '') => {
    if (!Array.isArray(textList)) {
        textList = Object.values(textList);
    }
    return textList.find(e => e.index === parseInt(itemId) && e.itemType === itemType)?.name || getETCItemName(itemId, productId);
}

export const getItemsNameAsNoneType = (textList, itemId) => {
    return textList.find(e => e.index === parseInt(itemId))?.name || itemId;
}

export const getItemInfo = (textList, itemId, itemType) => {
    return textList.find(e => e.index === parseInt(itemId) && e.itemType === itemType) || itemId;
}

export const getPackageName = (packageData, productId) => {
    return Object.values(packageData).find(pkg => pkg.packageId === productId)?.packageName;
}

export const getPayName = (textList, itemId) => {
    if (itemId === 9001) return '무료';
    else if (itemId === 9002) return '광고 시청';
    return textList.find(e => e.index === parseInt(itemId) && e.itemType === 1)?.name || itemId;
}

export const getMailTitle = (mailTitle, textList, title) => {
    if(!isNaN(title)){
        title = mailTitle.find(e => e.index === parseInt(title))?.title.find(e => e.langCode === 'ko')?.text || title;
    }

    if(!isNaN(title)){
        title = textList.find(e => e.index === parseInt(title))?.name || title;
    }

    return title;
}

export const STALE_TIME = 0;

export const DEFAULT_LOG_SEARCH_PARAM = {
    begin: dayjs().subtract(7, 'day').startOf('day').unix(),
    end: dayjs().endOf('day').unix(),
    logType: '',
    isUnix: true,
};

export const compareVersions = (a, b) => {
    const pa = String(a).split('.').map(Number);
    const pb = String(b).split('.').map(Number);
    for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
        const na = pa[i] || 0;
        const nb = pb[i] || 0;
        if (na !== nb) return na - nb;
    }
    return 0;
};

export const sanitizeJson = (input) => {
    let fixed = input.trim();
    fixed = fixed.replace(/'/g, '"');
    fixed = fixed.replace(/([{,]\s*)([^"\s:]+)\s*:/g, '$1"$2":'); // 모든 비따옴표 키 감싸기 (한글 포함)
    fixed = fixed.replace(/,\s*([}\]])/g, '$1');
    return fixed;
};